module.exports = __webpack_public_path__ + "static/Lunchbox-cc8b4e4b93483925eef0ffcd7a148162.jpg";